import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './firebaseConfig';  // Initialize Firebase before App renders
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();
